import React from 'react';
import { Section, Reveal, SectionTitle } from './Section';
const pains = [{
  emoji: '😩',
  text: 'Los domingos sigues corrigiendo mientras todos descansan.'
}, {
  emoji: '⏰',
  text: 'Una simple tanda de evaluaciones puede quitarte toda la tarde.'
}, {
  emoji: '✍️',
  text: 'Escribes una y otra vez los mismos comentarios para diferentes estudiantes.'
}, {
  emoji: '📊',
  text: 'Calcular notas y registrar resultados te consume demasiado tiempo.'
}, {
  emoji: '📚',
  text: 'Las evaluaciones se acumulan y cada semana empiezas más atrasada.'
}, {
  emoji: '🏠',
  text: 'Llegas a casa… pero el trabajo nunca termina.'
}];
export function PainPoints() {
  return <Section className="bg-brand-cream" data-id="element-161">
      <Reveal className="text-center" data-id="element-162">
        <SectionTitle data-id="element-163">
          ¿Te identificas con alguna de estas situaciones?
        </SectionTitle>
        <p className="mx-auto mt-3 max-w-xl text-base font-semibold text-brand-purpleDark/70" data-id="element-164">
          Si respondiste “Sí” a una de ellas, este sistema fue creado para ti.
        </p>
      </Reveal>

      <div className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-165">
        {pains.map((p, i) => <Reveal key={p.text} delay={i * 0.05} className="flex items-start gap-3 rounded-2xl bg-white p-4 shadow-sm ring-1 ring-brand-purple/10" data-id="element-166">
            <span className="text-2xl leading-none" aria-hidden data-id="element-167">
              {p.emoji}
            </span>
            <p className="text-sm font-semibold text-brand-purpleDark/85" data-id="element-168">
              {p.text}
            </p>
          </Reveal>)}
      </div>

      <Reveal className="mt-8 rounded-3xl bg-brand-purpleDark p-6 text-center" data-id="element-169">
        <p className="font-display text-xl font-extrabold leading-snug text-white sm:text-2xl" data-id="element-170">
          No necesitas trabajar más horas.{' '}
          <span className="text-brand-teal" data-id="element-171">
            Necesitas un sistema más inteligente.
          </span>
        </p>
      </Reveal>
    </Section>;
}